import { useCallback, useState } from 'react'
import { getActiveTagNames } from '@playbooks/action-cards-utils/src'
import { ActionCardsElement } from '@playbooks/action-cards/types'
import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

import { checkCompletionKeywords } from '../services/completionKeywordsService'
import useMountEffect from './useMountEffect'

// This hook checks if the active tags (actionCardData.conditionalItems)
// match the completion keywords defined in the settings.
function useCompletionKeywordsMatch({
  completionKeywords,
  actionCardsElementRef,
}: {
  completionKeywords: Set<string | null> | null
  actionCardsElementRef: React.RefObject<ActionCardsElement | null>
}) {
  const [isCompletionKeywordsMatched, setIsCompletionKeywordsMatched] = useState(false)

  const adjustCompletionKeywordsState = useCallback(() => {
    if (!actionCardsElementRef.current?.getValue() || !actionCardsElementRef.current) return

    const keywords = getActiveTagNames(actionCardsElementRef.current.getValue() as ActionCard)

    setIsCompletionKeywordsMatched(checkCompletionKeywords(keywords, completionKeywords) ?? false)
  }, [actionCardsElementRef, completionKeywords])

  useMountEffect(() => {
    adjustCompletionKeywordsState()
  })

  return { isCompletionKeywordsMatched, adjustCompletionKeywordsState }
}

export default useCompletionKeywordsMatch
